import { CallInterface } from '@customHooks/voice-call/use-voice-call';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAgoraRTCClient, IMicrophoneAudioTrack } from 'agora-rtc-sdk-ng';

interface RtcClient {
    localAudioTrack: IMicrophoneAudioTrack | null;
    client: IAgoraRTCClient | null;
}

interface IVoiceCallSlice 
{ 
    rtc: RtcClient, 
    call: CallInterface | undefined, 
    audioTrack: IMicrophoneAudioTrack | undefined,
    answered: boolean
}

export const voiceCallSlice = createSlice({
    name: 'voiceCall',
    initialState: {
        rtc: {
            localAudioTrack: null,
            client: null,
        },
        call: undefined,
        audioTrack: undefined,
        answered: false
    } as IVoiceCallSlice,
    reducers: {
        setRtcClient: (state, action: PayloadAction<RtcClient>) => {
            state.rtc.client = action.payload.client;
            state.rtc.localAudioTrack = action.payload.localAudioTrack
        },
        setCurrentCall: (state, action: PayloadAction<CallInterface | undefined>) => {
            if(action.payload) {
                state.call = {...action.payload};
            } else {
                state.call = undefined;
                state.answered = false;
            }
        },
        setAnswered: (state, action: PayloadAction<boolean>) => {
            state.answered = action.payload;
        },
        setCurrentAudioTrack: (state, action: PayloadAction<IMicrophoneAudioTrack | undefined>) => {
            if(action.payload) {
                state.audioTrack = action.payload;
            } else {
                state.audioTrack = undefined;
            }
        },
        resetRtcClient: (state) => {
            state.rtc.client = null;
            state.rtc.localAudioTrack = null;
            state.answered = false;
        },
        setCleanVoiceCall: (state) => {
            state = {
                rtc : {
                    localAudioTrack: null,
                    client: null,
                },
                call: undefined,
                audioTrack: undefined,
                answered: false
            }
        }
    },
});

export const { setRtcClient, resetRtcClient, setCurrentCall, setCurrentAudioTrack, setAnswered, setCleanVoiceCall } = voiceCallSlice.actions;
export default voiceCallSlice.reducer;